    import IcomoonReact from 'icomoon-react';
    import iconSet from '../assets/icons/selection.json'; // Adjust path as needed

    export default function Mi_icono_cnrc(props) {
      return (
        <IcomoonReact iconSet={iconSet} icon="logo_cnrc" size={props.size} color={props.color} />
      );
    }